<template>
  <InstagramToolPage
    h1-title="Instagram Story Downloader"
    subtitle="Save a public Story or Story link while it is still available on Instagram."
    input-placeholder="Paste Instagram Story or post URL"
    action-label="Download"
    limitation-note="Stories expire. Public links only."
    current-tool-path="/instagram-story-downloader/"
    :faqs="faqs"
  >
    <ToolContentSections :sections="storyDownloaderSections" />
  </InstagramToolPage>
</template>

<script>
import InstagramToolPage from '@/components/InstagramToolPage.vue';
import ToolContentSections from '@/components/ToolContentSections.vue';
import { storyDownloaderSections } from '@/data/instagram-tool-page-content';

export default {
  name: 'InstagramStoryDownloaderPage',
  components: { InstagramToolPage, ToolContentSections },
  data () {
    return {
      storyDownloaderSections,
      faqs: [
        {
          question: 'Can I download anyone’s Story anonymously?',
          answer: 'SnapInsta does not bypass Instagram privacy. If you cannot view the Story on Instagram, you cannot download it here.',
        },
        {
          question: 'How long do Stories stay available?',
          answer: 'Most Stories leave the profile ring after about 24 hours unless the owner saves them to Highlights or their archive.',
        },
        {
          question: 'Why did my Story link stop working?',
          answer: 'The Story likely expired or was deleted. Copy a new link while the Story is still live.',
        },
        {
          question: 'Should I use the Reels tool instead?',
          answer: 'Reels use permanent post links (instagram.com/reel/…). Stories need a Story-specific or temporary link—see our <a href="/instagram-reels-downloader/">Reels downloader</a> for Reels only.',
        },
      ],
    };
  },
};
</script>
